<app-bottom-sheet [isOpen]="isOpen()"
                  (isOpenChange)="isOpen.set($event)"
                  [headerTemplate]="title() ? headerTpl : undefined"
                  [contentTemplate]="contentTpl"
                  [hasFooter]="hasFooter()"
                  [isFullScreen]="isFullScreen()"
                  [backgroundClass]="backgroundClass()"
                  [preventOverlayClose]="preventOverlayClose()"
                  [enableSwipeToDismiss]="true"
                  [leftButtonText]="leftButtonText()"
                  [rightButtonText]="rightButtonText()"
                  [leftButtonDisabled]="leftButtonDisabled()"
                  [rightButtonDisabled]="rightButtonDisabled()"
                  (leftButtonClick)="leftButtonClick.emit()"
                  (rightButtonClick)="rightButtonClick.emit()"
                  (overlayClick)="overlayClick.emit()" />

<ng-template #headerTpl>
  <div class="sheet-header"
       [attr.data-testid]="testId() + '-header'">
    <p class="sheet-title">{{ title() }}</p>
  </div>
</ng-template>

<ng-template #contentTpl>
  <div class="sheet-body"
       [attr.data-testid]="testId() + '-body'">
    <ng-content />
  </div>
</ng-template>